'use client'

import dynamic from 'next/dynamic'
import { useChatbotDialog } from '../../hooks/useChatbotDialog'

const DynamicChatDialog = dynamic(() =>
	import('./ChatDialog/ChatDialog').then((mod) => mod.ChatDialog)
)

export function Chatbot() {
	const { isDialogOpen } = useChatbotDialog()

	return isDialogOpen ? <DynamicChatDialog /> : null
}
